import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import {
  LPSoftwareMobileApp,
  LPSoftwareWeb,
  LPSoftwareCustom,
  LPSoftwareGame,
  LPSoftwareSaas,
  LPSoftwareBlockchchain,
  LPSoftwareCloud,
  LPSoftwareAI,
  LPSoftwareStaff,
} from "../../../../app-constants-updated";

function Coreservices() {
  return (
    <section className="core_services p-100">
      <Container>
        <Row>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="text-center">
            <h2>
              Core <span>Services</span> We Provide
            </h2>
            <p>
              We provide solutions to all your requirements. Here’s a list of
              all the services we offer
            </p>
          </Col>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="mt-3 mt-md-4"
          >
            <Swiper
              loop={true}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
              }}
              // autoplay={false}
              spaceBetween={20}
              modules={[Autoplay, Pagination]}
              pagination={{
                clickable: true,
              }}
              breakpoints={{
                320: {
                  slidesPerView: 2,
                },
                768: {
                  slidesPerView: 3,
                },
                992: {
                  slidesPerView: 4,
                },
                1200: {
                  slidesPerView: 5,
                },
                1600: {
                  slidesPerView: 6,
                },
              }}
              className="lp-core-services"
            >
              <SwiperSlide>
                <div className="core-box">
                  <div className="core-icon">{LPSoftwareMobileApp}</div>
                  <div className="core-content">
                    <h5>Mobile App Development</h5>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="core-box">
                  <div className="core-icon">{LPSoftwareWeb}</div>
                  <div className="core-content">
                    <h5>Web Development</h5>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="core-box">
                  <div className="core-icon">{LPSoftwareCustom}</div>
                  <div className="core-content">
                    <h5>Custom Software Development</h5>
                  </div>
                </div>
              </SwiperSlide>

              <SwiperSlide>
                <div className="core-box">
                  <div className="core-icon">{LPSoftwareGame}</div>
                  <div className="core-content">
                    <h5>Game Development</h5>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="core-box">
                  <div className="core-icon">{LPSoftwareSaas}</div>
                  <div className="core-content">
                    <h5>SaaS Development</h5>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="core-box">
                  <div className="core-icon">{LPSoftwareBlockchchain}</div>
                  <div className="core-content">
                    <h5>Blockchain Development</h5>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="core-box">
                  <div className="core-icon">{LPSoftwareCloud}</div>
                  <div className="core-content">
                    <h5>Cloud Consulting</h5>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="core-box">
                  <div className="core-icon">{LPSoftwareStaff}</div>
                  <div className="core-content">
                    <h5>Staff Augmentation</h5>
                  </div>
                </div>
              </SwiperSlide>
            </Swiper>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Coreservices;
